Agpm = {
    pregFormat(term) {

        var patterns = {
            '[aáàâ]': '[aáàâ]',
            '[cç]': '[cç]',
            '[eéèêë]': '[eéèêë]',
            '[iîï]': '[iîï]',
            '[oôö]': '[oôö]',
            '[uùûü]': '[uùûü]',
            '\t+': ' ',
            '\r+': ' ',
            '\n+': ' ',
            '\'+': ' ',
            '\-+': ' ',
            '^ +': '',
            ' +$': '',
            ' +': '[' + String.fromCharCode(9) + String.fromCharCode(10) + String.fromCharCode(13) + '\' -]+'
        };

        for (var pattern in patterns) {
            term = term.replace(new RegExp(pattern, 'gi'), patterns[pattern]);
        }

        return term;
    }
}

window.showPassword = function (input) {
    let inputId = $(input).attr('data-ref');
    let inputRef = $(inputId);

    if(!$(input).prop("checked") && $(inputRef).attr('type') === 'password'){
        $(inputRef).attr('type','text');
    }
    else{
        $(inputRef).attr('type','password');
    }
};
